import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Lookup } from 'src/app/models/lookup.model';
import { trackById } from 'src/app/shared/utils/track-by.util';

@Component({
    standalone: false,
    selector: 'app-account-segmented-control',
    templateUrl: './account-segmented-control.component.html',
    styleUrls: ['./account-segmented-control.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountSegmentedControlComponent {
    @Input() options: Lookup[] = [];
    @Input() value: number | string | null = null;
    @Input() label = '';
    @Input() compact = false;
    @Output() valueChange = new EventEmitter<number | string>();

    readonly trackById = trackById;

    select(option: Lookup): void {
        if (option.id === this.value) return;
        this.valueChange.emit(option.id);
    }
}
